import styled from "styled-components";
import {Text} from "./Shared";
import {solease_cultured, solease_lightblue} from "../../constants/Colors";

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 25px;

  ${Text}{
    margin-bottom: 5px;
  }

  @media (min-width: 900px){
    max-width: 60%;
  }
`

const Input = styled.textarea`
  width: 100%;
  min-height: 78px;
  background-color: ${solease_cultured};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-size: 14px;
  padding: 10px 15px;
  outline: none;
  transition: all .3s;
  border: 1px solid transparent;
  resize: none;
}

&:focus {
  border-color: ${solease_lightblue};
}
`

const StyledTextarea = ({label}: { label: string }) => {

    return (
        <Wrapper>
            <label>
                <Text large>{label}</Text>
                <Input/>
            </label>
        </Wrapper>
    )
}

export default StyledTextarea
